// extracted by mini-css-extract-plugin
export default {"edit_license_key_modal":"styles_edit_license_key_modal__d7zxE","edit_license_key_modal_actions":"styles_edit_license_key_modal_actions__HvSH0"};